export const preloadLivePagesComponents = async () => {
	return (
		await import(
			/* webpackChunkName: "loadable-livePages-preloader" */
			'./livePages-preloader'
		)
	).preloadLivePagesComponents();
};
